import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Pipes
import { SlugifyPipe } from '../../utils/pipes/slugify-pipe';
import { DisplayFnPipe } from '../../utils/display-fn.pipe';
import { RentRateLabelFnPipe } from '../../utils/rent-rate-label-fn.pipe';
import { GetTranslationFnPipe } from '../../utils/translation-fn.pipe';
import { CustomerNameFnPipe } from '../../utils/customer-name-fn.pipe';
import { CustomerAddressTooltipFnPipe } from '../../utils/customer-address-tooltip-fn.pipe';
import { AddressTooltipFnPipe } from '../../utils/address-tooltip-fn.pipe';
import { SmartCapitalizePipe } from '../../utils/pipes/smart-capitalize.pipe';

// Directives
import { KeyPressDirective } from '../../utils/key-press-directive.directive';
import { NumericDirective } from '../../utils/numeric-directive.directive';
import { DecimalDirective } from '../../utils/decimal-directive.directive';
import { DateValidatorDirective } from '../../utils/date-validator-directive.directive';
import { ClickOutSideDirective } from '../../utils/click-outside-directive.directive';
import { ToNumberPipe } from '../../utils/to-number.pipe';
import { DoubleClickDirective } from '../../utils/double-click-directive.directive';
import { CustomCurrencyPipe } from '../../utils/pipes/custom-currency.pipe';
import { AvailabilitySearchPipePipe } from '../../utils/pipes/availability-search-pipe.pipe';
import { ivEnabledForResiProjectsDirective } from '../../utils/enabled-for-resi-projects.directive';
import { EnabledForPartialCreditDirective } from '../../utils/enable-for-partial-credit.directive';

@NgModule({
  declarations: [
    SlugifyPipe,
    KeyPressDirective,
    NumericDirective,
    DecimalDirective,
    DateValidatorDirective,
    ClickOutSideDirective,
    ToNumberPipe,
    DoubleClickDirective,
    DisplayFnPipe,
    RentRateLabelFnPipe,
    GetTranslationFnPipe,
    CustomerNameFnPipe,
    CustomerAddressTooltipFnPipe,
    AddressTooltipFnPipe,
    CustomCurrencyPipe,
    AvailabilitySearchPipePipe,
    ivEnabledForResiProjectsDirective,
    EnabledForPartialCreditDirective,
    SmartCapitalizePipe
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    SlugifyPipe,
    KeyPressDirective,
    NumericDirective,
    DecimalDirective,
    DateValidatorDirective,
    ClickOutSideDirective,
    ToNumberPipe,
    DoubleClickDirective,
    DisplayFnPipe,
    RentRateLabelFnPipe,
    GetTranslationFnPipe,
    CustomerNameFnPipe,
    CustomerAddressTooltipFnPipe,
    AddressTooltipFnPipe,
    CustomCurrencyPipe,
    AvailabilitySearchPipePipe,
    ivEnabledForResiProjectsDirective,
    EnabledForPartialCreditDirective,
    SmartCapitalizePipe
  ]
})
export class PipesDirectivesModule { }
